import React from "react";
import { Link } from "react-router-dom";
import { Heart, ArrowRight } from "lucide-react";

/**
 * Bandeau d'orientation vers /aidants. La majorité des premiers contacts
 * viennent d'un enfant ou d'un conjoint, pas du bénéficiaire lui-même : la
 * page d'accueil, écrite à la deuxième personne, ne leur parlait pas.
 */
const BandeauAidants = () => (
  <section className="py-12 bg-orange-50 border-y border-orange-100">
    <div className="container mx-auto px-4">
      <div className="max-w-4xl mx-auto flex flex-col md:flex-row items-center gap-6 md:gap-10">
        <Heart className="text-orange-700 flex-shrink-0" size={44} />
        <div className="flex-1 text-center md:text-left">
          <h2 className="text-2xl font-bold text-gray-900 mb-2">
            Vous cherchez pour votre père ou votre mère ?
          </h2>
          <p className="text-gray-700 leading-relaxed">
            Qui fait la demande, quels revenus sont pris en compte, quels délais prévoir,
            et comment aborder le sujet sans braquer : nous avons réuni les réponses aux
            questions que posent les enfants et les conjoints aidants.
          </p>
        </div>
        <Link
          to="/aidants"
          className="inline-flex items-center gap-2 bg-orange-700 text-white font-bold px-6 py-4 rounded-lg hover:bg-orange-800 transition-colors flex-shrink-0"
        >
          Guide de l'aidant
          <ArrowRight size={20} />
        </Link>
      </div>
    </div>
  </section>
);

export default BandeauAidants;
